<template>
    <div>
        <v-card >
            <v-card-title class="blue_corp white--text">
                COTIZACIÓN
                <v-spacer></v-spacer>
                <v-btn @click="search_cotizaciones()" x-small color="#EDE8D0" rounded>
                    Editar Cotización                
                    <v-icon class="ml-2" small>find_replace</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="5">
                        <v-sheet class="mt-2" rounded="xl" style="border:1px solid lightgrey">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="8">
                                        <v-alert class='text-caption' v-if="existe=='si'" dense text type="success">
                                            Orden Existe !!!
                                        </v-alert>
                                        <v-alert class='text-caption' v-else-if="existe=='no'" dense text type="warning">
                                            Nueva Orden !!!
                                        </v-alert>
                                        <v-alert class='text-caption' v-else dense text type="info">
                                            Selecciona Datos !!!
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12" md="4" class="text-center">
                                        <h5>N° Orden Cotización</h5>
                                        <h4 class="brown--text">{{ orden }}</h4>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n5">
                                    <v-col cols="12" md="8" class="d-flex">
                                        <v-combobox v-if="pcotiza===true" @change="numeroCliente(Cliente)" :hint="rutCliente" persistent-hint class='text-caption' v-model="Cliente" :items="itemCliente" label="Cliente" dense outlined disabled filled rounded></v-combobox>
                                        <v-text-field v-else class='text-caption' :hint="rutCliente" persistent-hint v-model="Cliente" label="Cliente" disabled filled outlined dense rounded></v-text-field>
                                        <v-btn @click="clientes=true" class="mt-1 ml-2" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="12" md="4" class="text-center">
                                        <v-btn class="ml-5 mr-5" color="teal" icon
                                            v-clipboard:copy="copiar" v-clipboard:success="onCopy" v-clipboard:error="onError">
                                            <v-icon>content_copy</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n7">
                                    <v-col cols="6" md="6">
                                        <v-text-field class='text-caption' v-model="direction" label="Direccion" outlined dense disabled filled rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-text-field class='text-caption' v-model="contact" label="Contacto" outlined dense disabled filled rounded></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n10">
                                    <v-col cols="12" md="12" class="text-end">
                                        <div v-if="itemsDirections.length > 1 || itemsContacts.length > 1">
                                            <v-btn @click="openDirecciones()" outlined color="indigo" x-small rounded><v-icon small>add_circle_outline</v-icon><span class="ml-2">Dirección y Contacto</span></v-btn>
                                        </div>
                                        <div v-else>
                                            <v-btn outlined color="grey" x-small rounded><v-icon small>add_circle_outline</v-icon><span class="ml-2">Dirección y Contacto</span></v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n7">
                                    <v-col cols="6" md="6">
                                        <h5>Servicio / Productos</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n5">
                                    <v-col cols="12" md="8" class="d-flex">
                                        <v-combobox :hint="SkuItem" persistent-hint class='text-caption' v-model="listaproducto" :items="itemProductos" item-text="name" label="Producto" dense outlined disabled filled rounded></v-combobox>
                                        <v-btn v-if="disabledBarra===true" class="mt-1 ml-2" small color="grey" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                                        <v-btn v-else @click="d_avanzado=true" class="mt-1 ml-2" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-select @change="buscaPrecio(listacodigo)" class='text-caption' v-model="miprecio" :items="itemsPrecio" label="Tipo Precio" dense outlined :disabled="disabledDatos" :filled="filledDatos" rounded></v-select>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n7">
                                    <v-col cols="12" md="4">
                                        <v-text-field class='text-caption' @keypress="onlyNumber" v-model="precio" label="Precio" outlined dense required disabled filled rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-select class='text-caption' @change="stockSku(bodega)" v-model="bodega" :items="itemBodegas" label="Bodega" dense outlined :hint="tStock" persistent-hint :disabled="disabledDatos" :filled="filledDatos" rounded></v-select>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-if="txtMedida!='Medida: UN'" class='text-caption' @keypress="onlyDecimal" v-model="cantidad" label="Cantidad" outlined dense required clearable :disabled="disabledDatos" :filled="filledDatos" rounded></v-text-field>
                                        <v-text-field v-else class='text-caption' @keypress="onlyNumber" v-model="cantidad" label="Cantidad" outlined dense required clearable :disabled="disabledDatos" :filled="filledDatos" rounded></v-text-field>
                                        <div class="mt-n7 ml-3"><span class="text-caption grey--text">{{txtMedida}}</span></div>
                                    </v-col>
                                    <v-col cols="12" md="1">
                                        <v-icon class="mt-2" v-if="txtMedida=='Medida: KG' || txtMedida=='Medida: LT'" @click="convierteFila()" color="success">track_changes</v-icon>
                                        <v-icon class="mt-2" v-else color="grey">track_changes</v-icon>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n5">
                                    <v-col cols="12" md="12" class="text-end">
                                        <v-btn  @click="saveVenta()" class="mt-1" small color="teal" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Grabar Producto</span></v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="7">
                        <v-container>
                            <h5>Detalle Productos</h5>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-simple-table fixed-header dense height="250px" style="border:1px solid lightgrey" class="text-size-cliente">
                                        <thead>
                                        <tr>
                                            <th style="width: 18%;background-color: lightgray;" class="text-start">SKU</th>
                                            <th style="width: 45%;background-color: lightgray;" class="text-start">PRODUCTO</th>
                                            <th style="width: 7%;background-color: lightgray;" class="text-start">CANT.</th>
                                            <th style="width: 8%;background-color: lightgray;" class="text-start">PRECIO</th>
                                            <th style="width: 20%;background-color: lightgray;" class="text-start">BODEGA</th>
                                            <th style="width: 2%;background-color: lightgray;" class="text-center">&nbsp;</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in items" :key="item.id">
                                                <td class="text-caption text-start">{{ item.sku }}</td>
                                                <td class="text-caption text-start">{{ item.producto }}</td>
                                                <td class="text-caption text-end">{{ item.cantidad }}</td>
                                                <td class="text-caption text-end">{{ item.precio }}</td>
                                                <td class="text-caption text-start">{{ item.bodega }}</td>
                                                <td class="text-caption text-center">
                                                    <v-icon @click="deleteVenta(item.id)" small color="error">delete</v-icon>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8" md="5">
                                    <v-text-field class='text-caption' v-model="observa" label="Observacion" outlined dense required clearable rounded></v-text-field>
                                </v-col>
                                <v-col cols="4" md="3">
                                    <v-btn  @click="saveObserva()" class="mt-1" small color="teal" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Confirmar Obs.</span></v-btn>
                                </v-col>
                                <v-col cols="12" md="4" class="text-end">
                                    <v-alert style="height:40px;" class='text-body-2' dense text border="left" color="red">
                                        <div class="mt-1 float-left">
                                            Total
                                        </div>
                                        <div class="mt-1 float-right">
                                            ${{new Intl.NumberFormat("de-DE").format(total)}}
                                        </div>                                             
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row class="mt-n7">
                                <v-col cols="12" md="6" class="d-flex">
                                    <h5 class="mt-1">Exponer PDF</h5>
                                    <v-btn v-if="items.length!=0" class="mt-n2 ml-2" @click="cotizaPDF()" color="indigo" dark icon large><v-icon large>print</v-icon></v-btn>
                                    <v-btn v-else class="mt-n2 ml-2" color="grey" dark icon large><v-icon large>print</v-icon></v-btn>
                                </v-col>
                                <v-col cols="12" md="6" class="text-end">
                                    <v-btn @click="newVenta()" class="mt-1" small color="teal" dark rounded><v-icon small>add_circle</v-icon><span class='text-btn'>Nueva Cotización</span></v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- dialog cotizaciones --> 
        <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="50%" persistent>
            <v-card>
                <v-card-title>
                    <v-btn @click="dialog=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field class='ml-5 mr-2 text-caption' v-model="likesearch" label="Buscar Cotización" dense required></v-text-field>
                </v-card-title>
                <v-card-text>
                    <v-data-table fixed-header height="400px" @click:row="handleCotiza" dense dark :search="likesearch" :headers="headers_cotiza" 
                        :items="items_cotiza" :page.sync="page" :items-per-page="itemsPerPage" 
                        hide-default-footer class="elevation-1 text-size-cliente" @page-count="pageCount = $event">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- dialog inventa --> 
        <v-dialog v-model="inventa" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="inventa=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
                <v-spacer>
                    <div class="float-right">
                    <v-text-field class='ml-5 mr-2 text-caption' v-model="inventasearch" label="Buscar Producto" dense required></v-text-field>
                    </div>
                </v-spacer>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleClick" dense dark :search="inventasearch" :headers="inventatitulo" :items="inventalista" :page.sync="inventapage" :items-per-page="inventaitemsPerPage"  @page-count="inventapageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="inventapage" :length="inventapageCount"  :total-visible="5"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- dialog clientes --> 
        <v-dialog v-model="clientes" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="clientes=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                <v-spacer>
                    <div class="float-right">
                    <v-text-field class='ml-5 mr-2 text-caption' v-model="clientesearch" label="Buscar Cliente" dense required></v-text-field>
                    </div>
                </v-spacer>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleClientes" dense dark :search="clientesearch" :headers="clientetitulo" :items="clientelista" :page.sync="clientepage" :items-per-page="clienteitemsPerPage"  @page-count="clientepageCount = $event" hide-default-footer class="elevation-1 text-size-cliente">
                </v-data-table>
                <v-pagination v-model="clientepage" :length="clientepageCount" :total-visible="5"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- dialog convierte --> 
        <v-dialog v-model="convierte" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-btn class="mt-2 ml-2" @click="convierte=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
            <v-card-title>
                Convertir Unidad de Medida ( 1 x ${{valorKG}} )
            </v-card-title>
            <v-card-text>
                <v-container>
                <v-row>
                    <v-col cols="12" md="3" class="text-center">
                        <v-text-field @keypress="onlyDecimal" v-model="cantidadKG" label="Cantidad" dense outlined :filled="filConvierte" :disabled="disConvierte"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                        <v-btn @click="cantidad_precio()" dark color="indigo"><v-icon>fast_forward</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                        <v-btn @click="precio_cantidad()" dark color="indigo"><v-icon>fast_rewind</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                        <v-text-field @keypress="onlyNumber" v-model="precioKG" label="Precio" dense outlined :filled="filConvierte" :disabled="disConvierte"></v-text-field>                        
                    </v-col>
                </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions class="mt-n10">
                <v-btn @click="no_aplica()" color="success" small>LIMPIAR</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="btnAplica==true" @click="si_aplica()" color="success" small>APLICAR</v-btn>
                <v-btn v-else color="grey" small>APLICAR</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <!-- dialog direcciones y contactos --> 
        <v-dialog v-model="d_directions" transition="dialog-bottom-transition" max-width="400" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="d_directions=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-select class='text-caption' v-model="myDireccion" :items="itemsDirections" item-text="direccion" item-value="direccion" label="Direccion" dense outlined></v-select>
                    <v-select class='text-caption' v-model="myContacto" :items="itemsContacts" item-text="contacto" item-value="contacto" label="Contacto" dense outlined></v-select>
                </v-container>
                <v-row>
                <v-col cols="12" md="12" class="text-center">
                    <v-btn @click="cambiarDireccion()" small rounded color="teal" dark>
                        <span class='text-btn'>Cambiar</span>
                    </v-btn>
                </v-col>
            </v-row>
            </v-card-text>
        </v-card>
        </v-dialog>
        <!-- dialogo Guia de Despacho -->
        <v-dialog v-model="d_guia" width="320" persistent>
            <v-card>
                <v-card-title>
                    <v-icon color="warning">warning</v-icon>
                </v-card-title>
                <v-card-text>
                    <span class="mt-2 text-body-2">Orden con Guia de Despacho: N° <strong>{{ arrayGuia.Numero }}</strong></span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="newVenta()" color="error" small rounded>cerrar</v-btn>
                </v-card-actions>
            </v-card>
         </v-dialog>

        <!-- dialog avanzado --> 
        <v-dialog v-model="d_avanzado" transition="dialog-bottom-transition" max-width="60%" persistent>
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-row>
                    <v-col cols="12" md="12" class="text-end">
                        <v-btn @click="d_avanzado=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="8">
                        <v-sheet style="border:1px solid lightgray" rounded="xl">
                            <v-container>
                                <h5>VEHÍCULO</h5>
                                <v-row class="mt-5">
                                    <v-col cols="12" md="6">
                                        <!-- <v-text-field class='mt-n5 casilla_beige text-body-2' v-model="car_marca" label="Marca" dense rounded></v-text-field> -->
                                        <v-select placeholder="Marca" @change="search_modelos(car_marca)" class='mt-n5 casilla_beige text-body-2 black--text' v-model="car_marca" :items="myMarcas" dense rounded></v-select>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <!-- <v-text-field class='mt-n5 casilla_beige text-body-2' v-model="car_modelo" label="Modelo" dense rounded></v-text-field> -->
                                        <v-select placeholder="Modelo" @change="search_cilindro()" class='mt-n5 casilla_beige text-body-2 black--text' v-model="car_modelo" :items="myModelos" dense rounded></v-select>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-5">
                                    <v-col cols="6" md="4">
                                        <v-text-field type="number" class='mt-n5 casilla_beige text-body-2' v-model="car_anio" label="Año" dense rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="6" md="4">
                                        <!-- <v-text-field @keypress="onlyDecimal" maxlength="3" class='mt-n5 casilla_beige text-body-2' v-model="car_cilindro" label="Cilindrada" dense rounded></v-text-field> -->
                                        <v-select placeholder="Cilindrada" class='mt-n5 casilla_beige text-body-2 black--text' v-model="car_cilindro" :items="myCilindros" dense rounded></v-select>
                                    </v-col>
                                    <v-col cols="12" md="4" class="text-center">
                                        <v-btn @click="searchRepuestos()" class="mt-n8" rounded color="#042955" dark small><span class="text-caption">Buscar Repuestos</span></v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" rounded="xl">
                            <v-container>
                                <h5>Código OEM</h5>
                                <v-row class="mt-5">
                                    <v-col cols="12" md="12">
                                        <v-text-field class='mt-n5 casilla_beige text-body-2' v-model="codigo_oem" placeholder="Codigo" dense rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="12" class="text-end">
                                        <v-btn @click="searchOem()" class="mt-n5" rounded color="#042955" dark small><span class="text-caption">Buscar Codigo</span></v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="6" md="4">
                        <v-text-field class='mt-n3 ml-2 text-body-2' v-model="car_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                    <v-col cols="6" md="8" class="text-right">
                        <v-btn @click="clear_avanzado()" class="mt-n7" rounded color="teal" dark small><span class="text-caption">Limpiar Lista</span></v-btn>
                    </v-col>
                </v-row>
                <v-row class="mt-n7">
                    <v-col cols="12" md="12">
                        <v-data-table height="300px" dense dark :search="car_search" :headers="car_titulo" :items="car_lista" :page.sync="car_page" :items-per-page="car_itemsPerPage"  @page-count="car_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                            <template v-slot:item.accion="{ item }">
                                <v-icon @click="selec_producto(item)" color="success">add_circle_outline</v-icon>
                            </template>
                            <template v-slot:item.Precio_Cliente="{ item }">
                                <span v-if="precioCliente=='Precio Detalle'">{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.PrecioLocal)) }}</span>
                                <span v-if="precioCliente=='Precio x Mayor'">{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.PrecioMayor)) }}</span>
                                <span v-if="precioCliente=='Precio Oferta'">{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.PrecioOferta)) }}</span>
                            </template>
                            <template v-slot:item.Codigos="{ item }">
                                <v-badge :content="item.Codigos" color="orange" overlap>
                                    <v-btn @click="getCodigos(item)" outlined rounded color="orange" x-small>
                                        ver codigos
                                    </v-btn>
                                </v-badge>
                            </template>
                            <template v-slot:item.Autos="{ item }">
                                <v-badge :content="item.Autos" color="orange" overlap>
                                    <v-btn @click="getAutos(item)" outlined rounded color="orange" x-small>
                                        ver vehículos
                                    </v-btn>
                                </v-badge>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="12">
                        <strong class="text-caption grey--text font-italic">
                            * Los precios de esta lista corresponden al tipo de precio configurado en el cliente seleccionado.
                        </strong>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- DIALOGO CODIGOS OEM -->
        <v-dialog v-model="d_codigos" transition="dialog-bottom-transition" max-width="500" persistent>
            <v-card>
            <v-toolbar color="primary" dark>Codigos Oem</v-toolbar>
            <v-card-text>                
                <v-row class="mt-2">
                    <v-col cols="12" md="12">
                        <v-simple-table fixed-header dense height="200px">
                            <thead>
                                <tr>
                                    <th style="background-color: beige;" class="text-start">Codigo</th>
                                    <th style="background-color: beige;" class="text-start">Proveedor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in lista_codigos" :key="item.ID">
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Codigo }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Proveedor }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="d_codigos=false" color="indigo" rounded outlined>x&nbsp;&nbsp;&nbsp;Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOGO VEHICULOS -->
        <v-dialog v-model="d_autos" transition="dialog-bottom-transition" max-width="500" persistent>
            <v-card>
            <v-toolbar color="primary" dark>Vehículos Compatibles</v-toolbar>
            <v-card-text>                
                <v-row class="mt-2">
                    <v-col cols="12" md="12">
                        <v-simple-table fixed-header dense height="200px">
                            <thead>
                                <tr>
                                    <th style="background-color: beige;" class="text-start">Marca</th>
                                    <th style="background-color: beige;" class="text-start">Modelo</th>
                                    <th style="background-color: beige;" class="text-start">Años</th>
                                    <th style="background-color: beige;" class="text-start">Cilindrada</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in lista_autos" :key="item.ID">
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Marca }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Modelo }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Desde }} - {{ item.Hasta }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Cilindro }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="d_autos=false" color="indigo" rounded outlined>x&nbsp;&nbsp;&nbsp;Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <img id="logo_emisor" src="" height="0" width="0"> 

        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"  />        
    </div>
</template>
<style scoped>
.text-size-cliente >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /*background-color: lightyellow;*/ 
}
.text-size >>> td {
    font-size: 9pt !important;
    height: 35px !important;
    /*background-color: lightyellow;*/ 
}
.col-color >>> th {
    background-color: lightgrey;
}
.casilla_beige {
    background-color: beige; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_grey {
    background-color: lightgray ; 
    height: 30px;
    border: 1px solid lightgray;
}
</style>
<script>
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
import { jsPDF } from "jspdf";
import axios from 'axios';
export default {
    name:'Venta', 
    components:{dialogo, snack},
    props: ['usu','contrato'],   
    data(){
        return{
            pcotiza:true,
            hoy:'',
            //contrato:'123',
            observa:'',
            tStock:'',
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            existe:'',
            disabledOrden:false,
            filledOrden:false,
            disabledDatos:true,
            filledDatos:true,
            disabledCheck:true,
            filledCheck:true,
            disabledBarra:true,
            filledBarra:true,
            soloOrden:true,
            btnGrabar:true,
            orden:'',
            itemCliente:[],
            arrayCliente:[],
            Cliente:'',
            listaproducto:'',
            listabarra:'',
            listanombre:'',
            listacodigo:'',
            itemProductos:[],
            arrayProductos:[],
            bodega:'',
            itemBodegas:[],
            arrayBodegas:[],
            precio:'',
            cantidad:'',
            radios:'Neto',
            total:0,
            nCliente:0,
            nProducto:0,
            nBodega:0,
            cv:'V',
            nVentas:0,

            //dialog Cotiza
            dialog:false,
            likesearch:'',
            page: 1,
            pageCount: 0,
            itemsPerPage: 1000000,
            items_cotiza:[],
            headers_cotiza: [
                { text: 'Fecha', align: 'start', sortable: true, value: 'fecha' },
                { text: 'Cotización', align: 'start', sortable: true, value: 'numero' },
                { text: 'Cliente', align: 'start', sortable: true, value: 'cliente' },
                { text: 'Monto', align: 'center', sortable: true, value: 'total' },
            ],

            items: [],
            itemsPrecio:['Precio Detalle','Precio x Mayor','Precio Oferta'], 
            miprecio:'',
            html:'',
            descargaCSV:false,
            rutaCSV:'',
            SkuItem:'',
            nStock:0,
            copiar:'',
            checkbox:false,
            rutCliente:'',
            rutSearch:'',
            impuesto:'',
            venta:0,
            inventa:false,
            inventasearch:'',
            inventatitulo:[
                { text: 'Sku', align: 'start', sortable: true, value: 'iSku', width:'' },
                { text: 'Producto', align: 'start', sortable: true, value: 'iProducto' },
                { text: 'Medida', align: 'start', sortable: true, value: 'iMedida' },
            ],
            inventalista:[],
            inventapage: 1,
            inventapageCount: 0,
            inventaitemsPerPage: 10,
            txtMedida:'',

            //dialogo clientes
            clientes:false,
            clientesearch:'',
            clientetitulo:[
                { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
                { text: 'Cliente', align: 'start', sortable: true, value: 'nombre' },
                { text: 'Alias', align: 'start', sortable: true, value: 'alias' },
            ],
            clientelista:[],
            clientepage: 1,
            clientepageCount: 0,
            clienteitemsPerPage: 10,

            // Convierte
            filaConvierte:[],
            convierte:false,
            valorKG:0,
            upCantidad:0,
            cantidadKG:0,
            precioKG:0,
            filConvierte:false,
            disConvierte:false,
            btnAplica:false,
            precioCliente:'',
            direction:'',
            contact:'',
            d_directions:false,
            myDireccion:'',
            myContacto:'',
            itemsDirections:[],
            itemsContacts:[],
            d_guia:false,
            arrayGuia:[],

            car_marca:'',
            car_modelo:'',
            car_anio:'',
            car_cilindro:'',
            d_avanzado:false,
            car_search:'',
            car_titulo:[
                { text: 'Selec.', align: 'center', sortable: false, value: 'accion'},
                { text: 'Sku', align: 'start', sortable: false, value: 'Sku'},
                { text: 'Producto', align: 'start', sortable: false, value: 'Producto'},
                { text: 'Stock', align: 'center', sortable: false, value: 'Stock'},
                { text: 'Precio', align: 'center', sortable: false, value: 'Precio_Cliente'},
                { text: 'Codigos Oem', align: 'center', sortable: false, value: 'Codigos'},
                { text: 'Compatibilidad', align: 'center', sortable: false, value: 'Autos'},
            ],
            car_lista:[],
            car_page: 1,
            car_itemsPerPage: 1000000,
            car_pageCount: 0,
            d_codigos:false,
            lista_codigos:[],
            d_autos:false,
            lista_autos:[],
            myMarcas:[],
            myModelos:[],
            myCilindros:[],
            codigo_oem:'',

            emisorPDF:[],
            clientePDF:[],

        }
    },
    async mounted(){
        await this.buscaCliente();
        await this.buscarProducto();
        await this.buscaImpuesto();
        //await this.buscarBodegas()
        //console.log(this.usu);
        await this.search_marcas();
        await this.searchEmisor();
    },
    methods:{
        async handleCotiza(line){
            const nOrden = line.numero;
            await this.buscaOrden(nOrden);
            this.dialog=false;
        },
        async search_cotizaciones(){
            this.loading=true;
            this.items_cotiza=[];
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/cotizaciones/pendientes/'+this.contrato);
            const datos=response.data;
            if (datos[0].existe=='si'){   
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    this.items_cotiza.push({
                        'fecha':element.Fecha,
                        'numero':element.Orden,
                        'cliente':element.Nombre,
                        'total':new Intl.NumberFormat("de-DE").format(parseFloat(element.Total)),
                        'usuario':element.Usuario,
                    });
                    // Orden descendente (de mayor a menor)
                    this.items_cotiza.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
                }              
            };
            this.dialog=true
            this.loading=false;
        },
        async searchEmisor(){
            try {
                this.emisorPDF=[];
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/emisor/' + this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.emisorPDF=datos;
                    //agregamos el logo al id
                    var img_logo = document.getElementById("logo_emisor")
                    img_logo.src = datos[0].Logo;
                }
            } catch (error) {
               console.log(error) 
            }
        },
        async search_marcas(){
            try {
                this.myMarcas=['FULL-MARCAS'];
                const params = this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/marcas/' + params);
                const datos=response.data;
                console.log('marcas:', datos);
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myMarcas.push(element.Marca);
                    })
                }              
            } catch (error) {
                console.log(error)
            }
        },
        async search_modelos(marca){
            try {
                this.myModelos=['FULL-MODELOS'];
                const params = marca + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/modelo/' + params);
                const datos=response.data;
                console.log('modelos:', datos);
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myModelos.push(element.Modelo);
                    })
                }              
            } catch (error) {
                console.log(error)
            }
        },
        async search_cilindro(){
            try {
                this.myCilindros=['FULL-CILINDRADA'];
                const params = this.car_marca + '/' + this.car_modelo + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/cilindro/' + params);
                const datos=response.data;
                console.log('cilindros:', datos);
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myCilindros.push(element.Cilindro);
                    })
                }              
            } catch (error) {
                console.log(error)
            }
        },
        async searchRepuestos(){
            this.codigo_oem='';
            if(this.car_marca==null || this.car_marca==''){
                this.car_marca = "FULL-MARCAS"
            }
            if(this.car_modelo==null || this.car_modelo==''){
                this.car_modelo='FULL-MODELOS'
            }
            if(this.car_anio==null || this.car_anio==''){
                this.car_anio = 0
            }
            if(this.car_cilindro==null || this.car_cilindro==''){
                this.car_cilindro='FULL-CILINDRADA'
            }
            try {
                const params = this.contrato + '/' + this.car_marca + '/' + this.car_modelo + '/' + this.car_anio + '/' + this.car_cilindro;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/v2/control/repuestos/' + params);
                const datos=response.data;
                console.log('datos de busqueda', datos)
                this.car_lista=[];
                if (datos[0].existe=='si'){
                    this.car_lista=datos;
                }                    
            } catch (error) {
                console.log(error)
            }
        },
        async searchOem(){
            if(this.codigo_oem!=null && this.codigo_oem!=''){
                this.car_marca='';
                this.car_modelo='';
                this.car_anio='';
                this.car_cilindro='';
                this.myCilindros=[];
                this.myModelos=[];
                this.lista_codigos=[];
                this.lista_autos=[];
                try {
                    const params = this.codigo_oem  + '/' + this.contrato;
                    const response = await axios.get(process.env.VUE_APP_URL + '/api/control/codigoem/' + params);
                    const datos=response.data;
                    this.car_lista=[];
                    if (datos[0].existe=='si'){
                        this.car_lista=datos;
                    }                    
                } catch (error) {
                    console.log(error)
                }                
            }
        },
        async getCodigos(line){
            this.loading=true;
            try {
                this.lista_codigos=[];
                const params = line.Sku + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/codigos/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.lista_codigos = datos;
                    this.d_codigos = true;
                }  
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        async getAutos(line){
            this.loading=true;
            try {
                this.lista_autos=[];
                const params = line.Sku + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/Compatibles/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.lista_autos = datos;
                    this.d_autos = true;
                }  
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        async selec_producto(select){
            const found = this.inventalista.filter(res => res.iSku == select.Sku);
            if(found.length!=0){
                const data = found[0];
                this.handleClick(data);
                this.d_avanzado=false;
            }
        },
        clear_avanzado(){
            this.car_marca='';
            this.car_modelo='';
            this.car_anio='';
            this.car_cilindro='';
            this.myCilindros=[];
            this.myModelos=[];
            this.lista_codigos=[];
            this.lista_autos=[];
            this.car_lista=[];
            this.codigo_oem='';
        },
        async saveObserva(){
            try {
                if(this.orden!=''){
                    const params={
                        contrato : this.contrato,
                        orden: this.orden,
                        observa: this.observa,
                    }
                    const response = await axios.put(process.env.VUE_APP_URL + '/api/inv/observa/cotiza/',params);
                    const datos=response.data;
                    if(datos=='si'){
                        this.Msg='La Observacion o referencia fue confirmada con exito';
                        this.msgbox=true;
                        this.color='success';
                        this.showSnack();
                    } else {
                        this.Msg='La Observacion o referencia no fue confirmada, intentelo mas tarde';
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }
                } else {
                    this.Msg='Ingrese la Observacion o Referncia';
                    this.msgbox=true;
                    this.color='info';
                    this.showSnack();
                }
            } catch (error) {
                console.log(error)
                this.Msg='La Observacion o referencia no fue confirmada, intentelo mas tarde';
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        async cambiarDireccion(){
            this.loading=true;
            try {
                let varDireccion='';
                let varComuna='';
                let varCiudad='';
                let varContacto='';
                let varTelefono='';
                let varEmail='';
                const filter = this.clientelista.filter(res => res.entidad == this.nCliente);
                //obtener data del direccion
                varDireccion = filter[0].direccion;
                varComuna = filter[0].comuna;
                varCiudad = filter[0].ciudad;
                //obtener data del contacto
                varContacto = filter[0].contacto;
                varTelefono = filter[0].telefono;
                varEmail = filter[0].email;

                if(this.itemsDirections.length!=0){
                    if(this.myDireccion!=''){
                        varDireccion=this.myDireccion
                        const found = this.itemsDirections.filter(res => res.direccion == this.myDireccion);
                        varComuna = found[0].comuna;
                        varCiudad = found[0].ciudad;
                    } 
                };
                if(this.itemsContacts.length!=0){
                    if(this.myContacto!=''){
                        varContacto=this.myContacto;
                        const found = this.itemsContacts.filter(res => res.contacto == this.myContacto);
                        varTelefono = found[0].fono;
                        varEmail = found[0].email;

                    }
                };

                const params={
                    entidad: this.nCliente,
                    contrato : this.contrato,
                    direccion: varDireccion,
                    comuna: varComuna,
                    ciudad: varCiudad,
                    contacto: varContacto,
                    telefono: varTelefono,
                    email: varEmail
                }
                const response = await axios.put(process.env.VUE_APP_URL + '/api/inv/clientes/direction/contact/',params);
                const datos=response.data;
                if(datos=='si'){
                    this.direction = varDireccion;
                    this.contact = varContacto;
                    await this.buscaCliente();
                }
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
            this.d_directions=false
        },
        async openDirecciones(){
            this.myDireccion='';
            this.myContacto='';
            this.d_directions=true;
        },
        async direcciones(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/clientes/direcciones/'+this.rutSearch+'/'+this.contrato);
                const datos=response.data;
                this.itemsDirections=[];
                if (datos[0].existe=='si'){
                    for (let index = 0; index < datos.length; index++) {
                        const element = datos[index];
                        this.itemsDirections.push({
                            id: element.ID,
                            direccion: element.Direccion,
                            comuna: element.Comuna,
                            ciudad: element.Ciudad
                        })
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async contactos(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/clientes/contactos/'+this.rutSearch+'/'+this.contrato);
                const datos=response.data;
                this.itemsContacts=[];
                if (datos[0].existe=='si'){
                    for (let index = 0; index < datos.length; index++) {
                        const element = datos[index];
                        this.itemsContacts.push({
                            id: element.ID,
                            contacto: element.Contacto,
                            fono: element.Telefono,
                            email: element.Email
                        })
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async convierteFila(){
            if(this.precio.trim()!='' && this.tStock.trim()!=''){
                this.convierte=true;
                this.valorKG=this.precio;
                this.cantidadKG=1;
                this.precioKG=this.precio;
                this.filConvierte=false;
                this.disConvierte=false;
                this.btnAplica=false;
            } else {
                this.Msg='Ingrese Precio y Local';
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        cantidad_precio(){
            if(this.cantidadKG.trim()!=''){
                if(!isNaN(this.cantidadKG)){
                    //aplicamos regla de 3
                    let valor=parseFloat(this.cantidadKG)*parseFloat(this.valorKG);
                    valor=parseInt(valor);
                    this.precioKG=valor;
                    this.upCantidad=this.cantidadKG;
                    this.filConvierte=true;
                    this.disConvierte=true;
                    this.btnAplica=true;
                } else {
                    this.Msg='Cantidad Invalida';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                    this.cantidad='';
                };
            }
        },
        precio_cantidad(){
            if(this.precioKG.trim()!=''){
                if(!isNaN(this.precioKG)){
                    //aplicamos regla de 3
                    let valor=parseFloat(this.precioKG)/parseFloat(this.valorKG);
                    this.upCantidad=valor;
                    valor=parseFloat(valor).toFixed(3);
                    this.cantidadKG=valor;
                    this.filConvierte=true;
                    this.disConvierte=true;
                    this.btnAplica=true;
                } else {
                    this.Msg='Cantidad Invalida';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                    this.cantidad='';
                };                
            }
        },
        no_aplica(){
            this.upCantidad=0;
            this.cantidadKG=1;
            this.precioKG=this.valorKG;
            this.filConvierte=false;
            this.disConvierte=false;
            this.btnAplica=false;
        },
        si_aplica(){
            if(!isNaN(this.upCantidad)){
                this.cantidad=this.cantidadKG;
                this.convierte=false
            } else {
                 this.no_aplica()
            }
        },
        async handleClick(txtOpcion) {
            console.log('data', txtOpcion);
            this.listanombre=txtOpcion.iProducto;
            this.listaproducto=txtOpcion.iProducto;
            this.listacodigo=txtOpcion.iSku;
            this.txtMedida='Medida: '+txtOpcion.iMedida;
            this.SkuItem="Sku: "+this.listacodigo;
            this.nProducto=this.listacodigo;
            await this.skuBodegas();
            this.miprecio=this.precioCliente;
            await this.buscaPrecio(txtOpcion.iSku);
            this.inventa=false;
        },
        async buscaImpuesto(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/impuesto/'+this.contrato);
            const datos=response.data;
            this.impuesto=0;
            if (datos[0].existe=='si'){
                this.impuesto=datos[0].Iva
            }
        },
        async fileCSV(){
            this.loading=true;
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/fileCsv/cotiza/'+this.contrato+'/'+this.orden+'/'+this.nCliente);
            const datos=response.data;
            //console.log(datos);
            if (datos=='si'){
                this.descargaCSV=true;
                this.rutaCSV=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+this.orden+'.csv';
            }
            this.loading=false;
        },
        editar(){
            this.newVenta();
            this.observa='';
            this.pcotiza=false;
            this.soloOrden=false;
        },

            onCopy: function (e) {
                this.Msg='Orden '+ e.text +' Copiada';
                this.msgbox=true;
                this.color='orange';
                this.showSnack();
            },
            onError: function (e) {
                this.Msg='Orden NO Copiada';
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            },

        async buscaOrden(nOrden){
            this.loading=true;
            try {
                if(nOrden!=''){
                    const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/orden/'+this.contrato+'/'+nOrden);
                    const datos=response.data;
                    console.log('datos de la orden', datos)
                    if (datos[0].existe=='si'){
                        this.existe='si' 
                        this.soloOrden=true;
                        this.disabledDatos=false;
                        this.filledDatos=false;
                        this.disabledBarra=false;
                        this.filledBarra=false;
                        this.orden=nOrden; 
                        this.Cliente=datos[0].Nombre;
                        this.precioCliente=datos[0].Precio_Cliente;
                        this.numeroCliente(this.Cliente);
                        this.observa=datos[0].ObservaCot;
                        let newTotal=0;
                        this.nVentas=0;
                        datos.forEach(element => {
                            newTotal=newTotal+parseFloat(element.Total); 
                            this.nVentas=parseFloat(this.nVentas)+parseFloat(element.Reg);                        
                        });
                        this.total=newTotal;
                        this.venta=newTotal+Math.round((newTotal*parseFloat(this.impuesto)/100));
                        this.copiar=''+nOrden;
                        //verificara si la orden tiene guia de despacho
                        const conGuia = await this.verificaGuia(nOrden);
                        if(conGuia=='si'){
                            this.d_guia = true
                        };
                        await this.dialogVentas();
                    } else {
                        this.existe='';
                        this.Msg='Orden no Existe o con DTE';
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    } 
                } else {
                    this.existe='';
                    this.Msg='Ingrese Orden';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        async verificaGuia(nOrden){
            let result = 'no';
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/verify/guide/'+ this.contrato +'/'+ nOrden);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.arrayGuia = datos[0];
                    result = 'si';
                } else { 
                    result = 'no' 
                }
            } catch (error) {
                console.log(error);
                result = 'no'
            }
            return result
        },
        onlyNumber ($event) {
         //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        onlyDecimal ($event) {
         //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        async dialogVentas(){
            if (this.nCompras!=0){
                this.descargaCSV=false;
                this.rutaCSV='';
                await this.datosDialog()
            }
        },
        async datosDialog(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/orden/entidad/'+this.cv+'/'+this.contrato+'/'+this.orden+'/'+this.nCliente);
            const datos=response.data;
            let newTotal;
            newTotal=0;
            this.items=[];
            if (datos[0].existe=='si'){   
                this.html=process.env.VUE_APP_URL + '/api/inv/prt/cotiza/v5/'+this.contrato+'/'+this.orden+'/'+this.nCliente;
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    const tMedida=await this.searchMedida(element.Sku);
                    //console.log(element.Cantidad);
                    this.items.push({
                        'id':element.ID,
                        'sku':element.Sku,
                        'producto':element.Producto,
                        'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                        'valor_precio':element.Precio,
                        'cantidad':new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)),
                        'valor_cantidad':element.Cantidad,
                        'medida':tMedida,
                        'bodega':element.Bodega,
                    });
                    newTotal=newTotal+(parseFloat(element.Precio)*parseFloat(element.Cantidad));
                }
            }
            this.total=newTotal;
            this.venta=Math.round(newTotal+(newTotal*parseFloat(this.impuesto)/100));
        },
        async searchMedida(mSku){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/unidad/medida/'+ this.contrato +'/'+ mSku);
                const datos=response.data;
                if (datos[0].existe=='si'){ 
                    return datos[0].Medida;
                } else { return 'Sin Medida' }
            } catch (error) {
                return 'Sin Medida'
            }
        },
        async deleteVenta(n){
            this.loading=true;
            const response = await axios.delete(process.env.VUE_APP_URL + '/api/inv/orden/entidad/delete/'+this.contrato+'/'+n);
            const datos=response.data;
            if (response.data=='ok'){
                await this.datosDialog()
                this.nVentas=this.nVentas-1
            }           
            this.loading=false;
        },
        clsInput(){
            this.tStock='';
            this.SkuItem='';
            this.disabledOrden=false;
            this.filledOrden=false;
            this.disabledDatos=true;
            this.filledDatos=true;
            this.disabledCheck=true;
            this.filledCheck=true;
            this.disabledBarra=true;
            this.filledBarra=true;
            this.soloOrden=true; 
            this.listaproducto='';    
            this.listabarra='';       
            this.listanombre='';
            this.listacodigo='';
            this.precio='';
            this.cantidad='';
            //this.observa='';
            this.nCliente=0;
            this.nProducto=0;
            this.bodega='';
            this.nBodega=0;
            this.existe='';
            this.nVentas=0;
            this.dialog=false;
            this.items=[];
            this.pcotiza=true;
            this.hoy='';
            this.html='';
            this.miprecio='';
            this.precio='';
            this.descargaCSV=false;
            this.rutaCSV='';
            this.nStock=0;
            this.copiar='';
            this.checkbox=false;
            this.rutCliente='';
            this.rutSearch='';
            this.inventasearch='';
            this.txtMedida='';
            this.direction='';
            this.contact='';
            this.itemsDirections=[];
            this.itemsContacts=[];
            this.d_guia=false;
            this.arrayGuia=[];
        },
        newVenta(){
            this.observa='';
            this.orden='';
            this.Cliente='';
            this.total=0;
            this.venta=0;
            this.clsInput()
        },
        async buscaCliente(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/lista/clientes/'+this.contrato);
            const datos=response.data;
            console.log(datos);
            this.itemCliente=[];
            this.arrayCliente=[];
            this.clientelista=[];
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    this.itemCliente.push(element.Nombre);
                    this.arrayCliente.push({id:element.ID,nombrecli:element.Nombre,rutcli:element.Rut});
                    this.clientelista.push({
                        entidad:element.ID,
                        nombre:element.Nombre,
                        rut:element.Rut,
                        email:element.Email,
                        telefono:element.Telefono,
                        direccion:element.Direccion,
                        comuna:element.Comuna,
                        ciudad:element.Ciudad,
                        giro:element.Observacion,
                        precio:element.Precio,
                        contacto:element.Contacto,
                        alias:element.Alias
                    })                
                });
            }
        },
        async handleClientes(fila) {
            this.Cliente=fila.nombre;
            this.precioCliente=fila.precio;
            console.log('Precio Cliente',this.precioCliente);
            await this.numeroCliente(fila.nombre);
            await this.solicitaOrden(fila.nombre);
            this.clientes=false
        },
        async buscarProducto(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/productos/'+this.contrato);
            const datos=response.data;
            //console.log(datos);
            this.itemProductos=[];
            this.arrayProductos=[];
            this.inventalista=[];
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    this.itemProductos.push({"name":element.Nombre,"code":element.Sku,"bar":element.Barra,"med":element.Medida});
                    this.arrayProductos.push({
                        sku:element.Sku,
                        nameSku:element.Nombre,
                        precioSku:element.PrecioLocal,
                        precioMayor:element.PrecioMayor,
                        precioOferta:element.PrecioOferta
                    });
                    this.inventalista.push({'iSku':element.Sku,'iProducto':element.Nombre,'iMedida':element.Medida});
                });
            }
        },
        async buscarBodegas(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/bodegas/'+this.contrato);
            const datos=response.data;
            //console.log(datos);
            this.itemBodegas=[];
            this.arrayBodegas=[];
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    this.itemBodegas.push(element.Nombre);
                    this.arrayBodegas.push({numBodega:element.ID,nameBodega:element.Nombre})        
                });
            }
        },
        CheckBarra(){
            this.listaproducto='';
            this.listanombre='';
            this.listacodigo='';
            this.SkuItem='';
            this.nProducto=0;
            if (this.checkbox===false){
                this.disabledCheck=true;
                this.filledCheck=true;
                this.disabledBarra=false;
                this.filledBarra=false;
                this.listabarra='';
            } else {
                this.disabledCheck=false;
                this.filledCheck=false;
                this.disabledBarra=true;
                this.filledBarra=true;
            }
        },
        search_SkuItem(itemPro){ // variable Global
            //console.log(itemPro);
            this.listanombre=itemPro.name;
            this.listacodigo=itemPro.code;
            this.txtMedida='Medida: '+itemPro.med;
            this.SkuItem="Sku: "+this.listacodigo;
            this.nProducto=this.listacodigo;
            this.skuBodegas();
        },
        search_BarraItem(codBarra){ // variable Global
            //console.log(codBarra);
            this.listaproducto='';
            this.listanombre='';
            this.listacodigo='';
            this.SkuItem='';
            this.nProducto=0;
            var elemento = document.getElementById("barr");
            elemento.blur();
            const resArray = this.itemProductos.find( datoArray => datoArray.bar === codBarra );
            if (resArray){
                this.listaproducto=resArray.name;
                this.listanombre=resArray.name;
                this.listacodigo=resArray.code;
                this.txtMedida="Medida: "+resArray.med;
                this.SkuItem="Sku: "+this.listacodigo;
                this.nProducto=this.listacodigo;
                this.skuBodegas();
            }
        },
        valorSku(SkuProducto){
            this.arrayProductos.forEach(element => {
                if (SkuProducto==element.sku){
                    switch (this.miprecio) {
                        case 'Precio Detalle':
                            this.precio=element.precioSku
                            break;
                        case 'Precio x Mayor':
                            this.precio=element.precioMayor
                            break;
                        case 'Precio Oferta':
                            this.precio=element.precioOferta
                            break;
                        default:
                            this.precio=''
                            break;
                    }
                }
            });
        },
        async numeroCliente(txtCliente){
            this.arrayCliente.forEach(element => {
                if (txtCliente==element.nombrecli){
                    this.nCliente=element.id;
                    this.rutCliente="Rut: "+element.rutcli;
                    this.rutSearch=element.rutcli;
                }
            });
            //buscamos la direccion y contacto del cliente
            const filter = this.clientelista.filter(res => res.entidad == this.nCliente);
            this.direction=filter[0].direccion;
            this.contact=filter[0].contacto
            this.clientePDF=filter;
            //agregamos a la lista 
            await this.direcciones();
            await this.contactos();
        },
        async numeroBodega(txtBodega){
            this.arrayBodegas.forEach(element => {
                if (txtBodega==element.nameBodega){
                    this.nBodega=element.numBodega
                }
            });
        },
        async stockSku(a){
            this.cantidad='';
            await this.numeroBodega(a);
            if (this.nBodega!=0){
                await this.totalStock();
            } else {
                this.tStock='Error de Bodega';
            }
        },
        async totalStock(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/stock/bodegas/producto/total/'+ this.contrato +'/'+ this.nBodega + '/' + this.nProducto);
            const datos=response.data;
            if (datos[0].existe=='si'){ 
                if(this.txtMedida!='Medida: UN'){
                    this.tStock='Total Stock: '+parseFloat(datos[0].Total).toFixed(3);
                } else {
                    this.tStock='Total Stock: '+parseInt(datos[0].Total);
                };
                this.nStock=datos[0].Total;
            }
            if (datos[0].existe=='no'){ 
                this.tStock='Sin Stock';
                this.nStock=0;
            } 
            if (datos[0].existe=='error'){ 
                this.tStock='Error de Stock';
                this.nStock=0;
            } 
        },
        async solicitaOrden(tCliente){
            this.clsInput();
            this.loading=true;
            const timestamp = Date.now();
            this.copiar=''+timestamp;
            //console.log(timestamp);
            this.orden=timestamp;
            const nOrden=timestamp;
            this.total=0;
            this.venta=0;
            if (Number.isInteger(nOrden/1)){
                if (tCliente.trim()!=''){
                    this.numeroCliente(tCliente);
                    this.disabledOrden=true;
                    this.filledOrden=true;
                    this.disabledDatos=false;
                    this.filledDatos=false;
                    this.disabledBarra=false;
                    this.filledBarra=false;
                    this.existe='no'                        
                } else {
                    this.Msg='Seleccione Cliente'
                    this.msgbox=true;
                    this.color='info';
                    this.showSnack();
                    this.newVenta()
                    this.existe=''                        
                }
            } else {
                this.Msg='Orden no Numerica'
                this.msgbox=true;
                this.color='info';
                this.showSnack();
                this.newVenta()
                this.existe=''                        
            }
            this.loading=false;
        },
        async buscaPrecio(SkuProducto){
            //console.log(SkuProducto);
            this.precio='';
            this.valorSku(SkuProducto);
        },
        async skuBodegas(){
            this.bodega='';
            this.itemBodegas=[];
            this.arrayBodegas=[];
            this.nBodega=0;
            this.tStock='';
            this.cantidad='';
            //this.observa='';
            this.miprecio='';
            this.precio='';
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/stock/bodegas/producto/'+ this.contrato +'/'+ this.nProducto);
            const datos=response.data;
            //console.log(datos);
            datos.forEach(element => {
                this.itemBodegas.push(element.Nombre);
                this.arrayBodegas.push({numBodega:element.ID,nameBodega:element.Nombre})        
            });
        },
        saveVenta(){
            this.loading=true;
            if(!isNaN(this.cantidad)){
                this.cantidad=this.cantidad;
            } else {
                this.cantidad='';
            }; 
            if (this.contrato!='' && this.orden!='' && this.Cliente!='' && 
                this.bodega!='' && this.cantidad!='' && this.precio!=''){
                if (this.nProducto!=0 && this.nCliente!=0 && this.nBodega!=0 && this.listanombre!=''){
                    if(this.usu.toUpperCase()!='ADMIN'){
                        if(this.nStock>=1 && this.nStock>=parseFloat(this.cantidad)){
                            this.save();
                        } else {
                            this.Msg='Producto Sin Stock'
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        }
                    } else {
                        console.log('el usuario ADMIN no verifica stock');
                        this.save();
                    }
                } else {
                    this.Msg='Intentelo Nuevamente'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.Msg='Datos sin Completar'
                this.msgbox=true;
                this.color='info';
                this.showSnack();
            }
            this.loading=false;
        },
        async save(){
            let canti=0;
            if(this.txtMedida!='Medida: UN'){
                canti=this.upCantidad;
            } else {
                canti=this.cantidad;
            };
            var parametros={
                'contrato': this.contrato,
                'orden': this.orden,
                'entidad': this.nCliente,
                'tipo': this.radios,
                'cv': this.cv,
                'sku':this.nProducto,
                'producto':this.listanombre,
                'precio':this.precio,
                'cantidad':canti,
                'bodega': this.nBodega,
                'observa':'',
                'usuario':this.usu,
                'referencia':'0',
                'cotiza':'si'
            };
            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/compraventa/cotiza/',parametros);
            const datos=response.data;
            //console.log(datos);
            if (datos=='si'){ 
                this.existe='si';    
                this.Msg='Producto Grabado !!!'
                this.msgbox=true;
                this.color='success';
                this.showSnack();
                this.disabledDatos=false;
                this.filledDatos=false;
                this.btnGrabar=false;
                this.nVentas++;
                this.total=this.total+(parseFloat(this.precio)*parseFloat(canti));
                this.venta=parseFloat(this.total)+Math.round((parseFloat(this.total)*parseFloat(this.impuesto)/100));
                this.listaproducto='';
                this.listanombre='';
                this.listacodigo='';
                this.miprecio='';
                this.precio='';
                this.bodega='';
                this.tStock='';
                this.SkuItem='';
                this.cantidad='';
                //this.observa='';
                this.listabarra='';
                this.txtMedida='';
                //enviamos el foco si check es true
                if(this.checkbox===true){
                    var elemento = document.getElementById("barr");
                    elemento.focus();
                };
                await this.dialogVentas();
            } 
            if (datos=='error'){
                this.Msg='Conexion Inestable, intentelo mas tarde'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
                this.newVenta();
                this.existe=''  
            }         
        },
        fechaNacional(fec){
            const dia = fec.substring(8,10);
            const mes = fec.substring(5,7);
            const anio = fec.substring(0,4);
            const hoy = dia + '-' + mes + '-' + anio;
            return hoy;
        },
        async cotizaPDF(){
            try {
                const doc = new jsPDF('p', 'mm', 'letter');
                //doc.addPage('p','mm','letter')

                doc.setLineWidth(1);
                doc.setDrawColor("#042955");
                doc.line(0.5, 0.5, 216, 0.5);

                //logo
                var img_log = document.getElementById("logo_emisor");
                doc.addImage(img_log,'PNG',2,2,50,35,'aliasEncima');

                //emisor
                const emisor = this.emisorPDF[0];
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(12);
                doc.text(('' + emisor.Razon_Social).toUpperCase(), 80, 8);
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(10);
                doc.text('' + emisor.Rut, 80, 13);
                console.log('largo cotiza', emisor.Giro.length);
                if(emisor.Giro.length >= 50){
                    doc.text('' + emisor.Giro, 80, 18, { maxWidth: 75 } );
                    doc.text('' + emisor.Direccion, 80, 27);
                    doc.text('' + emisor.Email, 80, 32);
                    doc.text('' + emisor.Telefono, 80, 37);
                } else {
                    doc.text('' + emisor.Giro, 80, 18);
                    doc.text('' + emisor.Direccion, 80, 23);
                    doc.text('' + emisor.Email, 80, 28);
                    doc.text('' + emisor.Telefono, 80, 33);
                };

                //numero cotiza
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(12);
                doc.setTextColor('#000');
                doc.text('N° COTIZACIÓN', 187, 18,{align: 'center'});
                doc.setTextColor(255,0,0); //color de la letra = rojo
                doc.text(('' + this.orden).toString(), 187, 25,{align: 'center'});

                doc.setLineWidth(1);
                doc.setDrawColor("#042955");
                doc.line(0.5, 40, 216, 40);

                //fecha
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(10);
                doc.text('FECHA:', 160, 45);                
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(11);
                const hoy = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
                doc.text('' + this.fechaNacional(hoy), 184, 45);

                //datos del cliente
                const client = this.clientePDF[0];
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(9);
                doc.text('DATOS DEL CLIENTE', 10, 50);
                doc.setLineWidth(0.8);
                doc.setDrawColor("#fe6501");
                doc.line(10, 51, 38, 51);

                doc.setTextColor('#000');
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(12);
                doc.text(('' + client.nombre).toUpperCase(), 10, 57);
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(10);
                doc.text('RUT', 10, 63);
                doc.text('GIRO', 10, 68);
                doc.text('DIRECCIÓN', 10, 73);
                doc.text('EMAIL', 10, 78);
                doc.text('CONTACTO', 10, 83);
                doc.setFontSize(11);
                doc.text(': ' + client.rut, 38, 63);
                doc.text(': ' + client.giro, 38, 68);
                doc.text(': ' + client.direccion, 38, 73);
                doc.text(': ' + client.email, 38, 78);
                doc.text(': ' + client.contacto, 38, 83);
                
                //encabezado detalle
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(9);
                doc.text('DETALLE SERVICIO / PRODUCTO', 10, 95);
                doc.setLineWidth(0.8);
                doc.setDrawColor("#fe6501");
                doc.line(10, 96, 54, 96);

                doc.setFillColor('#042955');
                doc.rect(10, 100, 198, 7, 'F'); 

                doc.setTextColor('#FFFFFF');
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(10);
                doc.text('SKU', 12, 104.5);
                doc.text('DESCRIPCIÓN', 45, 104.5);
                doc.text('CANT.', 150, 104.5);
                doc.text('PRECIO', 170, 104.5);
                doc.text('TOTAL', 190, 104.5);


                //detalle productos
                console.log('items',this.items)
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "noramal");
                doc.setFontSize(10);
                let line=112;
                this.items.forEach(element => {
                    doc.text('' + element.sku, 12, line);
                    doc.text('' + element.producto, 45, line);
                    doc.text('' + element.cantidad, 158, line,{align: 'right'});
                    doc.text('' + element.precio, 180, line,{align: 'right'});
                    const total_line = parseFloat(element.valor_precio) * parseFloat(element.valor_cantidad);
                    doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(total_line)), 200, line,{align: 'right'});
                    line = line + 5;
                });

                //total
                line = line + 1
                doc.setFillColor('#042955');
                doc.rect(150, line, 58, 7, 'F');
                doc.setTextColor('#FFFFFF'); 
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(12);
                line = line + 5
                doc.text('TOTAL:', 155, line);
                doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(this.total)), 202, line,{align: 'right'});

                //pie de pagina
                //doc.setTextColor('#f9f9f9'); 
                doc.setTextColor('#A9A9A9');
                doc.setFont("Helvetica", "italic");
                doc.setFontSize(8);
                doc.text(('' + emisor.Razon_Social).toUpperCase() + ' - ' + emisor.Email , 100, 270,{align: 'center'});

                doc.output('dataurlnewwindow')

            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>